module.exports = __webpack_public_path__ + "assets/img/LTC022.bea1c5b6.png";